<script setup lang="ts">
  // Table content
  const columnTypes = [
    {
      type: 'unique_id',
      description: 'Unique identifier column (e.g., subject ID)',
      example: 'Unique identifier column (e.g., subject ID)'
    },
    {
      type: 'index',
      description: 'Index column (similar to unique_id)',
      example: 'Index column (similar to unique_id)'
    },
    {
      type: 'carry',
      description: 'Column to carry along with the data',
      example: 'Column to carry along with the data'
    },
    {
      type: 'pivot',
      description: 'Column to pivot on (e.g., parameter codes)',
      example: 'Column to pivot on (e.g., parameter codes)'
    },
    {
      type: 'value',
      description: 'Column containing values to be pivoted',
      example: 'Column containing values to be pivoted'
    },
    {
      type: 'pass',
      description: 'Column to pass through without modification',
      example: 'Column to pass through without modification'
    },
    {
      type: 'statistical',
      description: 'Column containing statistical values',
      example: 'Column containing statistical values'
    },
    {
      type: 'stats',
      description: 'Alias for statistical',
      example: 'Alias for statistical'
    }
  ]
</script>
<template>
  <div style="max-height: 550px; overflow-y: auto">
    <table class="popover-table">
      <thead>
        <tr>
          <th>Type</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in columnTypes" :key="row.type">
          <td>
            <code>{{ row.type }}</code>
          </td>
          <td>{{ row.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  .popover-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  .popover-table th,
  .popover-table td {
    border: 1px solid #ddd;
    padding: 6px 10px;
    text-align: left;
  }
  .popover-table th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  code {
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 4px;
  }
</style>
